import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import { groupData } from './common';

const getTitleString = (title) =>
  title === 'Caves'
    ? I18n.t('dashboard.feedTitles.cave')
    : I18n.t('dashboard.feedTitles.restaurant');

export function extractDistributionGroupData(list, title) {
  const sortKeysHashMap = {
    year: 'year',
    month: 'month',
    market_name: 'origin'
  };

  const sameFunc = (acc, curr) => {
    const previous = acc[acc.length - 1];
    previous.toRedirectDistribution.wine.push({
      label: curr.marque_name || curr.wine_name,
      value: curr.marque_name || curr.wine_name
    });

    const nameString = curr.marque_name || curr.wine_name;
    const isInString = I18n.t('dashboard.feedDescriptions.isIn');

    previous.descriptionList.push(
      `${nameString} ${isInString} ${curr.dn} ${getTitleString(title)}`
    );
    return acc;
  };

  const diffFunc = (acc, curr) => {
    const momentDate = moment(curr.release_date);
    const name = curr.marque_name || curr.wine_name;
    const network_code = title === 'Caves' ? 'OFF' : 'ON';
    const isInString = I18n.t('dashboard.feedDescriptions.isIn');

    acc.push({
      ...curr,
      type: 'distribution',
      toRedirectDistribution: {
        market: curr.market_name,
        wine: [{ label: name, value: name }],
        network_code
      },
      title: getTitleString(title),
      order: 1,
      link: getLinkDistribution(curr, title),
      origin: curr.market_name,
      date: momentDate.format('DD/MM/YYYY'),
      momentDate,
      descriptionList: [
        `${name} ${isInString} ${curr.dn} ${getTitleString(title)}`
      ]
    });
    return acc;
  };

  return groupData(list, sortKeysHashMap, sameFunc, diffFunc);
}

function getLinkDistribution(item, title) {
  const linkMap = {
    'Ventes Primeur': `distribution/primeur/?vintage=${item.vintage}&date=${item.date}`,
    Caves: '/distribution/restaurants',
    Restaurants: '/distribution/restaurants',
    'Ventes en Ligne': '/distribution/online-sales/overview'
  };
  return linkMap[title] || null;
}

export function extractDistributionData(list, title) {
  const roundPrice = (price) => Math.round((price + 0.00001) * 100) / 100;

  return list.map((item) => {
    const momentDate = moment(item.date);

    const titleString = title.includes('Primeur')
      ? I18n.t('dashboard.feedTitles.primeur')
      : I18n.t('dashboard.feedTitles.onlineSales');

    const distributionForString = I18n.t(
      'dashboard.feedDescriptions.distributionFor'
    );
    const distributionAtString = I18n.t(
      'dashboard.feedDescriptions.distributionAt'
    );

    return {
      type: 'distribution',
      title: titleString,
      link: getLinkDistribution(item, title),
      order: 3,
      origin: item.store_name,
      date: momentDate.format('DD/MM/YYYY'),
      momentDate,
      description: `${item.type} ${distributionForString} ${item.wine_name} ${
        item.vintage
      } : ${item.store_name} ${distributionAtString} ${roundPrice(
        item.local_price
      )} ${item.local_currency}`
    };
  });
}
